import { render } from "./Files.vue?vue&type=template&id=0da1ff64&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"

import "./Files.vue?vue&type=style&index=0&id=0da1ff64&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da1ff64"]])

export default __exports__